// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as RequestAccessRouteImport } from './routes/request-access'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuthenticatedAddRouteImport } from './routes/_authenticated/add'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedCheckoutReturnRouteImport } from './routes/_authenticated/checkout-return'
import { Route as AuthenticatedCompleteProfileRouteImport } from './routes/_authenticated/complete-profile'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedPlansRouteImport } from './routes/_authenticated/plans'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedSalaryRouteImport } from './routes/_authenticated/salary'
import { Route as AuthenticatedSubscriptionsRouteImport } from './routes/_authenticated/subscriptions'
import { Route as ToolsRealWageGrowthCalculatorRouteImport } from './routes/tools.real-wage-growth-calculator'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const RequestAccessRoute = RequestAccessRouteImport.update({
            id: '/request-access',path: '/request-access',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAddRoute = AuthenticatedAddRouteImport.update({
            id: '/add',path: '/add',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCheckoutReturnRoute = AuthenticatedCheckoutReturnRouteImport.update({
            id: '/checkout-return',path: '/checkout-return',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCompleteProfileRoute = AuthenticatedCompleteProfileRouteImport.update({
            id: '/complete-profile',path: '/complete-profile',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPlansRoute = AuthenticatedPlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSalaryRoute = AuthenticatedSalaryRouteImport.update({
            id: '/salary',path: '/salary',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSubscriptionsRoute = AuthenticatedSubscriptionsRouteImport.update({
            id: '/subscriptions',path: '/subscriptions',getParentRoute: () => AuthenticatedRouteRoute
          })
const ToolsRealWageGrowthCalculatorRoute = ToolsRealWageGrowthCalculatorRouteImport.update({
            id: '/tools/real-wage-growth-calculator',path: '/tools/real-wage-growth-calculator',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAddRoute: AuthenticatedAddRoute,AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedCheckoutReturnRoute: AuthenticatedCheckoutReturnRoute,AuthenticatedCompleteProfileRoute: AuthenticatedCompleteProfileRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedPlansRoute: AuthenticatedPlansRoute,AuthenticatedProfileRoute: AuthenticatedProfileRoute,AuthenticatedSalaryRoute: AuthenticatedSalaryRoute,AuthenticatedSubscriptionsRoute: AuthenticatedSubscriptionsRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,ContactRoute: ContactRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,RegisterRoute: RegisterRoute,RequestAccessRoute: RequestAccessRoute,ResetPasswordRoute: ResetPasswordRoute,TermsRoute: TermsRoute,ToolsRealWageGrowthCalculatorRoute: ToolsRealWageGrowthCalculatorRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)